/**
 * Product Page template
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const NAME = "ProductPage";

const variantOptions = document.querySelector("variant-radios");
const radiosPickers = variantOptions?.querySelectorAll(".pack-picker");
radiosPickers ? require("./components/packsPicker") : "";
// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
/**
 * init - Initialize the page
 **/

// Update finace price in PDP product container
document.addEventListener('DOMContentLoaded' , () => {
    const product = document.querySelector('.product');
    const selectOptions = product.querySelector('.product-form__input select');
    const primaryRegularPrice = product.querySelector('.price__container');

    const updateFinancePrice = () => {
        const financePrice = product.querySelector('.finance-price-text span.money');
        let regularPrice = product.querySelector('.price-item.price-item--last span.money').textContent;

        let removeSymbolPrice = regularPrice.slice(0, -1);
        let priceNumber = Number(removeSymbolPrice);

        let diffPrice = (priceNumber / 12).toFixed(0);
        financePrice.innerHTML = `${diffPrice}€`;
    }

    const priceContainer = new MutationObserver((mutations) => {
        mutations.forEach(mutation => {
            if (mutation.addedNodes.length > 0) {
                updateFinancePrice();
            }
        });
    })

    priceContainer.observe(primaryRegularPrice.parentElement.parentElement, { childList: true, subtree: false });
})